import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83e79e7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-global space-y-8" }
const _hoisted_2 = { class: "page-title text-gray-800" }
const _hoisted_3 = { class: "company-details-layout flex" }
const _hoisted_4 = { class: "flex-1 h-96 overflow-y-auto" }
const _hoisted_5 = { class: "flex-1 p-4 space-y-4" }
const _hoisted_6 = { class: "page-title" }
const _hoisted_7 = { class: "space-y-4" }
const _hoisted_8 = { class: "flex flex-col gap-2" }
const _hoisted_9 = { for: "name" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "flex flex-col gap-2" }
const _hoisted_13 = { for: "counteragent" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  id: "counteragent",
  class: "input-form"
}, null, -1))

import BackButton from "@/components/common/BackButton.vue";
import { ref, onMounted } from "vue";
import { TreeItem } from "@/components/common";
import { CompanyDataService } from "@/services/";
import { Company } from "@/types";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const companyTree = ref([]);

const selectedCompany = ref<Company>();

onMounted(async () => {
  const response = await CompanyDataService.getParents();
  const companies: Company[] = response.data.data;
  companies.forEach((c) => {
    if (!c.parentId) {
      companyTree.value.push(c);
    } else {
      const parent = companies.find((p) => p.id === c.parentId);
      if (parent) {
        parent.children = [...(parent.children || []), c];
      }
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'CompanyList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)("companyDetails.title")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(TreeItem), {
            item: {
            name: _unref(t)('companyDetails.departments'),
            children: companyTree.value,
          },
            setParentId: () => {},
            onSelect: _cache[0] || (_cache[0] = ($event: any) => (selectedCompany.value = $event))
          }, null, 8, ["item", "setParentId"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", _hoisted_6, _toDisplayString(selectedCompany.value?.name || _unref(t)("companyDetails.selectCompany")), 1),
          _createElementVNode("form", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, [
                _createTextVNode(_toDisplayString(_unref(t)("companyDetails.branchName")) + " ", 1),
                _hoisted_10
              ]),
              _createElementVNode("input", {
                type: "text",
                id: "name",
                placeholder: selectedCompany.value?.name,
                class: "input-form"
              }, null, 8, _hoisted_11)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, [
                _createTextVNode(_toDisplayString(_unref(t)("companyDetails.counteragentEsedo")) + " ", 1),
                _hoisted_14
              ]),
              _hoisted_15
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})